const loaderElement = document.querySelector('#global-loader')
//loaderElement.classList.add("hide")
let isPrevLoaderFullScreen = false
const hideLoaderElement = (isFullScreen = false, isModeChange = false) => {
    if(isFullScreen && isPrevLoaderFullScreen) loaderElement.classList.add("hide")
    if(!isFullScreen && !isPrevLoaderFullScreen) loaderElement.classList.add("hide")
    if(isFullScreen) isPrevLoaderFullScreen = false

    if(isModeChange) loaderElement.classList.add("hide")
}

const showLoaderElement = (isFullScreen = false, isModeChange = false) => {
    if(isFullScreen) isPrevLoaderFullScreen = true
    if(isFullScreen !== isPrevLoaderFullScreen && !isModeChange) return;
    
    loaderElement.style.width = isFullScreen ? "100vw" : document.querySelector(".d3d-container canvas").style.width
    loaderElement.style.height = isFullScreen ? "100vh" : document.querySelector(".d3d-container canvas").style.height

    document.querySelector(".loader-procent").style.display = isFullScreen ? "block" : "none"
    
    loaderElement.classList.remove("hide")

    if(isModeChange){
        document.querySelector(".preloader_filled").style.display = "none"
        document.querySelector(".preloader_text").style.display = "block"
        document.querySelector(".loader-container").style.background = "white"
    }else{
        document.querySelector(".preloader_filled").style.display = "block"
        document.querySelector(".preloader_text").style.display = "none"
        document.querySelector(".loader-container").style.background = "#eaeef1"
    }
}

export {hideLoaderElement, showLoaderElement}